var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVolumeZero(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "8.35 0 5 5 -8.8817842e-16 5 -8.8817842e-16 15 5 15 8.35 20 10 20 10 0"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.80354128,0.196924664 C7.54120765,-0.0656415546 7.1162929,-0.0656415546 6.85395927,0.196924664 L3.98772093,3.06745612 L1.16396389,0.237001892 C0.999109655,0.0527259026 0.746200341,-0.0252170843 0.506539181,0.0343931207 C0.266878021,0.0940033257 0.0796584253,0.281418263 0.0198715066,0.521568575 C-0.0399154121,0.761718887 0.0375077053,1.01533117 0.221128904,1.18082061 L3.04563561,4.00676615 L0.201887373,6.86477347 C-0.0396539447,7.1308872 -0.0300163173,7.54026709 0.223778875,7.79466421 C0.477574067,8.04906134 0.885985318,8.05872183 1.15146939,7.81660764 L4.00271433,4.9661148 L6.82647137,7.79907385 C6.99462592,7.97106726 7.24197337,8.03929376 7.47424069,7.97774975 C7.706508,7.91620575 7.88791033,7.73437318 7.94930872,7.50155499 C8.0107071,7.2687368 7.94264204,7.02080271 7.77105558,6.85224934 L4.93980184,4.02179511 L7.80354128,1.14875883 C8.06548624,0.885803014 8.06548624,0.459880478 7.80354128,0.196924664 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeZero);
export default __webpack_public_path__ + "static/media/volume-zero.18786602.svg";
export { ForwardRef as ReactComponent };